'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { NotificationsContext } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/NotificationsContextShared.js';
import { useCallback, useState } from 'react';
export const NotificationsProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => {
        setIsOpen(true);
    }, []);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    return (_jsx(NotificationsContext.Provider, { value: {
            isOpen,
            open,
            close,
        }, children: children }));
};
//# sourceMappingURL=NotificationsContext.js.map